import { Flex, Menu, MenuContent, MenuTrigger, Text } from '@optiaxiom/react';
import { useDecision } from '@optimizely/react-sdk';

import { AgentStatus, AgentType } from '../../../hooks/useAgentsUrlParams';

type AgentFiltersProps = {
  agentType?: AgentType;
  status?: AgentStatus;
  onAgentTypeChange: (type?: AgentType) => void;
  onStatusChange: (status?: AgentStatus) => void;
};

export function AgentFilters({
  agentType,
  status,
  onAgentTypeChange,
  onStatusChange,
}: AgentFiltersProps) {
  const [workflowAgentFeature] = useDecision('workflow-agent');

  const getTypeLabel = () => {
    switch (agentType) {
      case 'specialized':
        return 'Specialized';
      case 'workflow':
        return workflowAgentFeature.enabled ? 'Workflow' : 'All Types';
      default:
        return 'All';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      default:
        return 'All';
    }
  };

  const agentTypeOptions = [
    {
      label: 'All',
      execute: () => onAgentTypeChange(undefined),
    },
    {
      label: 'Specialized',
      execute: () => onAgentTypeChange('specialized'),
    },
  ];

  if (workflowAgentFeature.enabled) {
    agentTypeOptions.push({
      label: 'Workflow',
      execute: () => onAgentTypeChange('workflow'),
    });
  }

  const statusOptions = [
    {
      label: 'All',
      execute: () => onStatusChange('all'),
    },
    {
      label: 'Active',
      execute: () => onStatusChange('active'),
    },
    {
      label: 'Inactive',
      execute: () => onStatusChange('inactive'),
    },
  ];

  return (
    <>
      <Menu options={agentTypeOptions}>
        <MenuTrigger h="40">
          <Flex gap="0">
            <Text textAlign="start" fontSize="sm">
              Type
            </Text>
            <Text textAlign="start" fontSize="xs">
              {getTypeLabel()}
            </Text>
          </Flex>
        </MenuTrigger>
        <MenuContent />
      </Menu>

      <Menu options={statusOptions}>
        <MenuTrigger h="40">
          <Flex gap="0">
            <Text textAlign="start" fontSize="sm">
              Status
            </Text>
            <Text textAlign="start" fontSize="xs">
              {getStatusLabel()}
            </Text>
          </Flex>
        </MenuTrigger>
        <MenuContent />
      </Menu>
    </>
  );
}
